import { render, staticRenderFns } from "./ThreadOverview.vue?vue&type=template&id=7cc3bacc&scoped=true"
import script from "./ThreadOverview.vue?vue&type=script&lang=ts"
export * from "./ThreadOverview.vue?vue&type=script&lang=ts"
import style0 from "./ThreadOverview.vue?vue&type=style&index=0&id=7cc3bacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc3bacc",
  null
  
)

export default component.exports